import { combineReducers } from "redux";
import authReducer from "./authReducer";
import notificationReducer from "./notificationReducer";
import commonReducer from "./commonReducer";
import tabReducer from "./tabReducer";
import candidateListReducer from "./candidateReducer";

const rootReducers = combineReducers({
  auth: authReducer,
  notification: notificationReducer,
  common: commonReducer,
  tab: tabReducer,
  candidates: candidateListReducer,
});

export default rootReducers;
